module.exports = __webpack_public_path__ + "img/pedro_tavares.095c983f.png";